import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Box from 'shopper/components/Box';

import SortSelect from 'components/SortSelect';

const OffersSortBox = ({ className, options, onSelectChange, ...rest }) => (
  <Box
    className={twMerge(
      'flex w-full flex-col items-center justify-end p-4 md:flex-row',
      className
    )}
    {...rest}
  >
    <SortSelect options={options} onSelectChange={onSelectChange} />
  </Box>
);

OffersSortBox.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      isSelected: PropTypes.bool,
    })
  ).isRequired,
  onSelectChange: PropTypes.func.isRequired,
};

export default OffersSortBox;
